import { Applicant, ApplicantList } from "@/modules/applicants/types";

export interface BusinessState {
  currentBusinessOwners: ApplicantList;
  currentBusiness: Business;
  selectedBusiness: Business;
  isViewing: string;
  businesses: BusinessList;
  allApprovedBusinesses: BusinessList;
  allRejectedBusinesses: BusinessList;
  allPendingBusinesses: BusinessList;
  sortOrder: string;
  sortBy: string;
  isFetchingBusinesses: boolean;
  isFetchingBusinessOwners: boolean;
  query: string;
}

export interface BusinessList {
  pageIndex: number;
  totalPages: number;
  totalItems: number;
  items: Business[];
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

export interface Business {
  id?: string;
  name: string;
  registrationNumber: number;
  country: string;
  documents: Array<BusinessDocument>;
  owners: Array<Applicant>;
  createdAt: string;
  processedByUser: ProcessingUser;
}

export interface ProcessingUser {
  disabled: boolean;
  email: string;
  firstName: string;
  id: string;
  lastName: string;
  role: number;
}

export interface BusinessDocument {
  id?: string;
  name: string;
}

export interface FetchPayload {
  status?: string;
}
export interface FetchCurrentBusinessPayload {
  id: string;
  status: string;
}

export interface FetchPaginatedBusinessesPayload {
  pageNumber: number;
  status: string;
}
export interface ToggleCompanyStatusPayload {
  id: string;
  action: string;
  onError: (message: string) => void;
}

export enum Status {
  PENDING = 0,
  APPROVED = 1,
  REJECTED = 2,
}
